import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {SystemConfigurationService} from '../pages/system-configuration/system-configuration.service';
import {HttpClient} from '@angular/common/http';
import {ConfigStateService} from '@abp/ng.core';
import {environment, wechatEnvironment} from '../../environments/environment';
import * as COS from 'cos-js-sdk-v5';
import {NzUploadXHRArgs} from 'ng-zorro-antd';
import {getYearMonth} from './calendar';
import * as fs from 'file-saver';
import * as _ from 'lodash';
import {NzUploadChangeParam, NzUploadFile} from '../components/upload';
import {MSG_TYPE} from '../enum/message.enum';
import {MessagesService} from '../services/messages.service';
import { NzMessageService } from 'ng-zorro-antd/message';

// 腾讯云COS类
export class COSFileUpload {
  uploadUrl = environment.apis.default.uploadUrl;
  fileKeys: any[] = [];
  fileNames: any[] = [];
  filePrefix: any = null;
  fileList: any[] = [];
  fileThumbList: NzUploadFile[] = [];
  imgUrl: any = null;
  cos: any; // 声明文件上传对象
  messageType = MSG_TYPE;
  fileFolder = 'businesscharge'; // 营收文件夹

  constructor(
    public systemService: SystemConfigurationService,
    private config: ConfigStateService,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    private bucket: string,
    private appId: string,
    private messagesService: MessagesService,
    private message?: NzMessageService,
  ) {
    const abpInfo = this.config.getAll() as any;
    this.filePrefix = this.fileFolder + '/' + abpInfo?.currentTenant?.name + '/' + getYearMonth(new Date()) + '/';
  }

  initCOS(fileSource, prefix) {
    const params = {
      fileSource,
      bucket: this.bucket,
      prefix,
    };
    this.cos = new COS({
      getAuthorization: (options, callback) => {
        this.systemService.getTempSecretKey(params).subscribe(
          data => {
            if (data?.Credentials) {
              callback({
                TmpSecretId: data.Credentials.TmpSecretId,        // 临时密钥的 tmpSecretId
                TmpSecretKey: data.Credentials.TmpSecretKey,      // 临时密钥的 tmpSecretKey
                XCosSecurityToken: data.Credentials.Token, // 临时密钥的 sessionToken
                StartTime: data.StartTime,  // 时间戳，单位秒，如：1580000000
                ExpiredTime: data.ExpiredTime,               // 时间戳，单位秒，如：1580000900
              });
            }
          },
          error => {
            console.error('credentials invalid', error);
          },
        );
      },
    });
  }

  beforeUpload = (file: NzUploadFile): any => {
    // this.fileList = this.fileList.concat(file);
  }

  customCOSUpload = (item: NzUploadXHRArgs) => {
    const fileName = item.file.name.split('.')[0] + '_' + new Date().getTime() + '.' + item.file.name.split('.')[1];
    // @ts-ignore
    const newFile = new File([item.file], fileName, {
      type: item.file.type,
    });
    // @ts-ignore
    newFile.uid = item.file.uid;
    this.fileList = this.fileList.concat(newFile);
    this.cos.putObject({
      Bucket: this.bucket + '-' + this.appId, /* 必须 */
      Region: 'ap-shanghai',     /* 存储桶所在地域，必须字段 */
      Key: this.filePrefix + newFile?.name,              /* 必须 */
      StorageClass: 'STANDARD',
      Body: newFile, // 上传文件对象
      onProgress: (progressData) => {
        // console.log(JSON.stringify(progressData));
        if (progressData.percent < 1) {
          // @ts-ignore
          newFile.status = 'uploading';
        } else {
          // @ts-ignore
          newFile.status = 'done';
        }
      },
    }, (err, data) => {
      // console.log('result', err || data);
      const index = _.findIndex(this.fileList, o => o.uid === item.file.uid);
      if (err) {
        this.fileList.splice(index, 1);
        if (this.message) {
          return this.message.error(`${newFile?.name}上传失败`);
        }
        return;
      }
      this.fileList[index].url = this.fileThumbList[index]?.thumbUrl;
      this.fileList[index].path = this.filePrefix + newFile?.name;
      this.fileList = [...this.fileList];
      this.fileKeys = this.fileKeys.concat({path: this.filePrefix + newFile?.name, name: newFile?.name});
      this.fileKeys = _.uniqWith(this.fileKeys, _.isEqual);
    });
  }

  HSCCOSUpload(item) {
    this.cos.putObject({
      Bucket: this.bucket + '-' + this.appId, /* 必须 */
      Region: 'ap-shanghai',     /* 存储桶所在地域，必须字段 */
      Key: this.filePrefix + item.file?.name,              /* 必须 */
      StorageClass: 'STANDARD',
      Body: item.file, // 上传文件对象
      onProgress: (progressData) => {
        // console.log(JSON.stringify(progressData));
        if (progressData.percent < 1) {
          item.file.status = 'uploading';
        } else {
          item.file.status = 'done';
        }
      },
    }, (err, data) => {
      // console.log('result', err || data);
      const index = _.findIndex(this.fileList, o => o?.file?.name === item.file.name);
      if (err) {
        this.fileList.splice(index, 1);
        if (this.message) {
          return this.message.error(`${item.file?.name}上传失败`);
        }
        return;
      }
      this.fileList[index].path = this.filePrefix + item.file?.name;
      this.fileList[index].name = item.file?.name;
      this.fileList = [...this.fileList];
      this.fileKeys = this.fileKeys.concat({path: this.filePrefix + item.file?.name, name: item.file?.name, fileType: item.fileType});
    });
  }

  handleChange(info: NzUploadChangeParam): void {
    this.fileThumbList = info.fileList;
  }

  removeFile = (file: NzUploadFile) => {
    this.fileKeys = _.uniqWith(this.fileKeys, _.isEqual);
    const index = _.findIndex(this.fileList, o => o.name === file.name);
    this.fileList.splice(index, 1);
    this.fileKeys.splice(index, 1);
  }

  checkCOSFile(key, isDownload, fileName?, fileType?, fileDataType?) {
    const index = this.fileList.length;
    this.fileList = [...this.fileList, {fileDataType: 'loading'}];
    this.cos.getObject({
      Bucket: this.bucket + '-' + this.appId, /* 必须 */
      Region: 'ap-shanghai',     /* 存储桶所在地域，必须字段 */
      Key: key,
      DataType: 'blob',
    }, (err, data) => {
      if (err) {
        return console.log(err);
      }
      const blob = new Blob([data.Body], {type: data.Body?.type});
      if (isDownload) {
        fs.saveAs(blob, fileName || data.expectedFileName);
      }
      this.imgUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
      const file = new window.File([blob], fileName || data.expectedFileName, {type: data.Body?.type});
      this.fileList[index] = {uid: key, name: fileName, status: 'done', url: this.imgUrl, originFileObj: file, fileType, fileDataType};
      this.fileKeys = [...this.fileKeys, {path: key, name: fileName, fileType}];
      if (isDownload) {
        const downloadUrl = data.Url + (data.Url.indexOf('?') > -1 ? '&' : '?') + 'response-content-disposition=attachment'; // 补充强制下载的参数
        window.open(downloadUrl); // 这里是新窗口打开 url，如果需要在当前窗口打开，可以使用隐藏的 iframe 下载，或使用 a 标签 download 属性协助下载
      }
    });
  }

  // 上传文件
  weChatHSCCOSUpload(item) {
    const fileName = item.file.name.split('.')[0] + '_' + new Date().getTime() + '.' + item.file.name.split('.')[1];
    // @ts-ignore
    const newFile = new File([item.file], fileName, {
      type: item.file.type,
    });
    // @ts-ignore
    newFile.uid = item.file.uid;
    return new Promise((resolve, reject) => {
      this.cos.putObject({
        Bucket: this.bucket + '-' + this.appId, /* 必须 */
        Region: 'ap-shanghai',     /* 存储桶所在地域，必须字段 */
        Key: this.filePrefix + newFile?.name,              /* 必须 */
        StorageClass: 'STANDARD',
        Body: newFile, // 上传文件对象
        onProgress: (progressData) => {
          // console.log(JSON.stringify(progressData));
        },
      }, (err, data) => {
        // console.log('result', err || data);
        if (err) {
          reject(err);
        }else{
          this.fileKeys = this.fileKeys.concat({path: this.filePrefix + newFile?.name, name: newFile?.name});
          resolve(data.Location);
        }
      });
    });
  }

  // promise方式返回
  weChatCheckCOSFile(key, isDownload, fileName?) {
    return new Promise((resolve, reject) => {
      this.cos.getObjectUrl({
        Bucket: this.bucket + '-' + this.appId, /* 必须 */
        Region: 'ap-shanghai',     /* 存储桶所在地域，必须字段 */
        Key: key,
      }, (err, data) => {
        if (err) {
          reject(err);
        }
        if (isDownload) {
          const downloadUrl = data.Url + (data.Url.indexOf('?') > -1 ? '&' : '?') + 'response-content-disposition=attachment'; // 补充强制下载的参数
          window.open(downloadUrl); // 这里是新窗口打开 url，如果需要在当前窗口打开，可以使用隐藏的 iframe 下载，或使用 a 标签 download 属性协助下载
        }
        this.imgUrl = data.Url;
        this.fileList = [...this.fileList, {uid: key, name: fileName, status: 'done', url: this.imgUrl}];
        this.fileKeys = [...this.fileKeys, {path: key, name: fileName}];
        resolve(this.imgUrl);
      });
    });
  }

  // 直接获取上传后的连接地址
  titleCustomCOSUpload(item: NzUploadXHRArgs) {
    const fileName = item.file.name.split('.')[0] + '_' + new Date().getTime() + '.' + item.file.name.split('.')[1];
    // @ts-ignore
    const newFile = new File([item.file], fileName, {
      type: item.file.type,
    });
    // @ts-ignore
    newFile.uid = item.file.uid;
    return new Promise((resolve, reject) => {
      this.cos.putObject({
        Bucket: this.bucket + '-' + this.appId, /* 必须 */
        Region: 'ap-shanghai',     /* 存储桶所在地域，必须字段 */
        Key: this.filePrefix + newFile?.name,              /* 必须 */
        StorageClass: 'STANDARD',
        Body: newFile, // 上传文件对象
        onProgress: (progressData) => {
          console.log(JSON.stringify(progressData));
        },
      }, (err, data) => {
        if (err){
          reject(err);
          // console.log('result', err);
        }else{
          resolve({url: 'https://' + data.Location, name: newFile?.name});
        }
        // const index = _.findIndex(this.fileList, o => o.name === item.file.name);
        // this.fileList[index].url = this.fileThumbList[index]?.thumbUrl;
        // this.fileList = [...this.fileList];
        // this.fileKeys = this.fileKeys.concat({url: 'http://' + data.Location, name: item.file?.name});
      });
    });
  }

  // 上传BOLB对象
  PUTOBJECTbolb(item){
    return new Promise((resolve, reject) => {
      this.cos.putObject({
        Bucket: this.bucket + '-' + this.appId, /* 必须 */
        Region: 'ap-shanghai', /* 存储桶所在地域，必须字段 */
        Key: ('' + new Date().valueOf() + Math.floor(Math.random() * 999999) + '.png'),   /* 必须 */
        ContentType: 'image/png',
        Body: item.file, // 上传文件对象
        onProgress: (progressData) => {
          // console.log(JSON.stringify(progressData));
        }
      }, (err, data) => {
        resolve(data.Location);
        console.log(err || data);
      });
    });
  }

  // 获取不带签名的对象url
  checkCOSFileNotSign(key, isDownload, fileName?, flag?) {
    this.cos.getObjectUrl({
      Bucket: this.bucket + '-' + this.appId, /* 必须 */
      Region: 'ap-shanghai',     /* 存储桶所在地域，必须字段 */
      Key: key,
      Sign: false
    }, (err, data) => {
      if (err) {
        // console.log('checkCOSFileNotSign', err);
        switch (flag){
          case 'login':
            localStorage.setItem('loginLogo', '../../../assets/images/login-logo.png');
            break;
          case 'menuBig':
            localStorage.setItem('menuLogoBig', '../../../assets/images/login-logo.png');
            break;
          case 'menuSmall':
            localStorage.setItem('menuLogoSmall', '../assets/images/index/menu-logo-small.png');
            break;
        }
        return;
      }
      if (isDownload) {
        const downloadUrl = data.Url + (data.Url.indexOf('?') > -1 ? '&' : '?') + 'response-content-disposition=attachment'; // 补充强制下载的参数
        window.open(downloadUrl); // 这里是新窗口打开 url，如果需要在当前窗口打开，可以使用隐藏的 iframe 下载，或使用 a 标签 download 属性协助下载
      }
      this.imgUrl = data.Url;
      switch (flag){
        case 'login':
          this.fileList = [];
          this.fileKeys = [];
          localStorage.setItem('loginLogo', data.Url || '');
          this.messagesService.sendMessage(
            {name: this.messageType.REFRESH_LOGIN_PIC, value: data.Url || ''}
          );
          break;
        case 'menuBig':
          this.fileList = [];
          this.fileKeys = [];
          localStorage.setItem('menuLogoBig', data.Url || '');
          this.messagesService.sendMessage({name: this.messageType.REFRESH_MENU_IMG_BIG});
          break;
        case 'menuSmall':
          this.fileList = [];
          this.fileKeys = [];
          localStorage.setItem('menuLogoSmall', data.Url || '');
          this.messagesService.sendMessage({name: this.messageType.REFRESH_MENU_IMG_SMALL});
          break;
      }
      this.fileList = [...this.fileList, {uid: key, name: fileName, status: 'done', url: data.Url}];
      this.fileKeys = [...this.fileKeys, {path: key, name: fileName}];
    });
  }
}

// 本地COS类
export class LocalFileUpload {
  uploadUrl = environment.apis.default.uploadUrl;
  weChatApi = wechatEnvironment.apis.default.url;
  accessToken = null; // 用户token
  httpHeader = null; // 请求头
  imgUrl: SafeResourceUrl;
  fileList: any[] = [];

  constructor(
    public systemService: SystemConfigurationService,
    private config: ConfigStateService,
    protected httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    private message?: NzMessageService,
  ) {
  }

  // TODO nz-upload配置样例
  setHeader = (file: NzUploadFile) => {
    this.accessToken = localStorage.getItem('access_token');
    this.httpHeader = 'Bearer ' + this.accessToken;
    return {Authorization: this.httpHeader};
  }

  getExtraData = (file: NzUploadFile) => {
    return {
      FileContainerName: 'default',
      FileType: 2,
      OwnerUserId: this.config.getAll()?.currentUser?.id,
      GenerateUniqueFileName: true,
    };
  }

  HSCLocalCOSUpload(item) {
    // const params = {
    //   File: item.file,
    //   FileContainerName: 'default',
    //   FileType: 2,
    //   OwnerUserId: this.config.getAll()?.currentUser?.id,
    //   GenerateUniqueFileName: true,
    // };
    const params = new FormData();
    params.append('File', item.file);
    params.append('FileContainerName', 'default');
    // @ts-ignore
    params.append('FileType', 2);
    params.append('OwnerUserId', this.config.getAll()?.currentUser?.id);
    // @ts-ignore
    params.append('GenerateUniqueFileName', true);
    const url = `${this.uploadUrl}/api/fileManagement/file`;
    const accessToken = localStorage.getItem('access_token');
    const httpHeader = 'Bearer ' + accessToken;
    // todo 获取item在file list里的index
    const index = _.findIndex(this.fileList, o => o.file?.name === item.file?.name);
    this.httpClient.post(url, params, {headers: {Authorization: httpHeader}}).subscribe(
      data => {
        // todo 如果成功，设置下标为index的file的status为done
        this.fileList[index] = {uid: item.file?.name, name: item.file?.name, url: (item.url as string), status: 'done',
          response: data, fileType: item.fileType};
        // this.fileList = [...this.fileList,
        //   {uid: item.file?.name, name: item.file?.name, url: (item.url as string), status: 'done',
        //   response: data, fileType: item.fileType}];
      },
      error => {
        console.error(error);
        // todo 如果失败，从file list里删除下标为index的元素
        this.fileList.splice(index, 1);
        this.message.error(`${item.file?.name}上传失败`);
      }
    );
  }

  checkLocalFile(id, isDownload, fileName?, fileType?, fileDataType?, isPDF?) {
    const index = this.fileList.length;
    this.fileList = [...this.fileList, {fileDataType: 'loading'}];
    this.systemService.localFileDownloadInfo(id).subscribe(
      data => {
        if (data.token) {
          const url = `${this.uploadUrl}/api/fileManagement/file/${id}/download`;
          const accessToken = localStorage.getItem('access_token');
          const httpHeader = 'Bearer ' + accessToken;
          this.httpClient.get(url, {
            headers: {Authorization: httpHeader}, responseType: 'blob', observe: 'response',
            params: {id, token: data.token},
          }).subscribe(
            result => {
              if (isPDF){
                const pdfUrl = window.URL.createObjectURL(new Blob([result.body], {type: 'application/pdf'}));
                window.open(pdfUrl);
              }else{
                const blob = new Blob([result.body], {type: result.body?.type});
                if (isDownload) {
                  fs.saveAs(blob, fileName || data.expectedFileName);
                }
                this.imgUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
                const file = new window.File([blob], fileName || data.expectedFileName, {type: result.body?.type});
                this.fileList[index] = {uid: id, name: fileName, status: 'done', url: this.imgUrl as string, fileType, originFileObj: file, fileDataType};
              }
              this.fileList = [...this.fileList];
              // this.fileList = [...this.fileList,
              //   {uid: id, name: fileName, status: 'done', url: this.imgUrl as string, fileType, originFileObj: file, fileDataType}];
            },
            err => {
              // console.log(err);
            },
          );
        }
      },
      error => {
        // console.log(error);
      },
    );
  }

  // 本地文件下载
  weChatCheckLocalFile(id){
    return new Promise((resolve, reject) => {
      const url = `${this.weChatApi}/api/app/bizChargeSystem/${id}/fileStream`;
      const accessToken = localStorage.getItem('access_token');
      const httpHeader = 'Bearer ' + accessToken;
      this.httpClient.get(url, {headers: {Authorization: httpHeader}, responseType: 'blob'}).subscribe(
        data => {
          const blob = new Blob([data], { type: data?.type });
          const objectURL = URL.createObjectURL(blob);
          const imageUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
          resolve(imageUrl);
          // this.blobToBase64(data).then(res => {
          // })
          // const blob = new Blob([data], { type: data.type });
          // const imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
          // console.log(imageUrl.changingThisBreaksApplicationSecurity);
          // resolve(imageUrl.changingThisBreaksApplicationSecurity);
        },
        error => {
          console.error(error);
        }
      );
    });
  }

  // 文章发布专用上传
  articleUpLoad(item) {
    return new Promise((resolve, reject) => {
      // const item = base64ToFile();
      const params = new FormData();
      params.append('files', item?.file);
      const url = `${this.weChatApi}/api/app/bizChargeSystem/uploadlocalFiles`;
      const accessToken = localStorage.getItem('access_token');
      const httpHeader = 'Bearer ' + accessToken;
      // todo 获取item在file list里的index
      const index = _.findIndex(this.fileList, o => o.file?.name === item?.file?.name);
      this.httpClient.post(url, params, {headers: {Authorization: httpHeader}}).subscribe(
        data => {
          // @ts-ignore
          resolve(data.fileName);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}

export function getBase64(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function base64ToFile(base64, fileName) {
  const arr = base64.split(',');
  const type = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, {type});
}
